import React from 'react';
import FormattedDate from 'src/components/10-atoms/date/FormattedDate';
import MoreOptionsButton from 'src/components/10-atoms/dropdown-menu/MoreOptionsButton';
import FeatherIcon from 'src/components/10-atoms/icons/FeatherIcon';
import Column from 'src/components/10-atoms/layout/Column';
import Row from 'src/components/10-atoms/layout/Row';
import Pressable from 'src/components/10-atoms/pressables/Pressable';
import Tag from 'src/components/10-atoms/Tag';
import Typography from 'src/components/10-atoms/typography/Typography';
import { TypographyVariant, } from 'src/customizations/themes/10-parts/typography';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const NoteItem = ({ note, onPress, onLongPress, to, menuOptions, style, ...columnProps }) => {
    const [{ theme, styles }] = useTheme(stylesGenerator);
    return (React.createElement(Pressable, { to: to, onPress: onPress, onLongPress: onLongPress },
        React.createElement(Column, { ph: theme.spacing.page, pv: theme.spacing.standard.md, spacing: theme.spacing.standard.xs, style: [styles.container, style], ...columnProps },
            React.createElement(Row, { xAxis: "space-between", yAxis: "center" },
                React.createElement(Typography, { flex: true, variant: TypographyVariant.BODY }, note.data.title),
                menuOptions && menuOptions.length > 0 && (React.createElement(Pressable, { onPress: (e) => e?.stopPropagation() },
                    React.createElement(MoreOptionsButton, { testID: "note-item-more-options", options: menuOptions, renderButton: () => (React.createElement(FeatherIcon, { name: "more-vertical", size: theme.iconSize.sm, color: theme.palette.icon.secondary })) })))),
            React.createElement(Row, { xAxis: "space-between", yAxis: "center" },
                React.createElement(Row, { flex: true, wrap: true, spacing: theme.spacing.standard.xxs }, note.data.topics.map(topic => (React.createElement(Tag, { key: topic }, topic)))),
                React.createElement(FormattedDate, { mode: "relative", date: note.utime, variant: TypographyVariant.CAPTION, color: theme.palette.typography.secondary })))));
};
const stylesGenerator = createThemedStyle(({ theme }) => ({
    container: {
        backgroundColor: theme.palette.background.subtle,
        borderRadius: theme.borderRadius.standard.md,
    },
}));
export default NoteItem;
